import {
  BookingIntroTitle,
  AppointmentInformation,
  PhoneSection,
} from '../components';

export const config = {
  SuccessBookingMessage: {
    paragraph: BookingIntroTitle,
  },
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
  BookingReview: {
    icsEvent: {
      timeBeforeAppointment: 10,
      isServiceNameIncludedToAppointmentTypeName: true,
    },
    locationAdditionalInformation: 'Located within the Beauty Hall',
    PhoneSectionComponent: PhoneSection,
  },
};
